import { render, staticRenderFns } from "./MaterialCSSelect.vue?vue&type=template&id=4c674daa&scoped=true&"
import script from "./MaterialCSSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialCSSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c674daa",
  null
  
)

export default component.exports